import { library } from '@fortawesome/fontawesome-svg-core';
import { faChevronRight,
         faChevronDown,
         faArrowAltCircleUp,
         faArrowAltCircleDown,
         faPlusSquare,
         faMinusSquare,
         faWindowClose,
         faChevronCircleDown,
         faChevronCircleRight,
         faStop,
         faPlay,
         faMinus,
         faPlus,
         faPlusCircle,
         faCheckCircle,
         faTimesCircle,
         faCogs,
         faSave,
         faBan,
         faCircle,
         faChartPie,
         faRedo,
         faInfoCircle,
         faNetworkWired,
         faTrashAlt,
         faCloudDownloadAlt,
         faTags,
         faBookmark,
         faEdit,
         faClipboard,
         faLink,
         faKey,
         faLock,
         faUnlock,
         faEllipsisV,
         faEllipsisH,
         faArrowRight,
         faArrowLeft,
         faToolbox,
         faMapPin,
         faCog,
         faStopCircle,
         faInfinity,
         faTimes,
         faDownload,
         faUpload,
         faBolt,
         faFileExport,
         faFileExcel,
        } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import {
          ValidationObserver,
          ValidationProvider,
          extend,
          localize,
        } from 'vee-validate';
import en from 'vee-validate/dist/locale/en.json';
import * as rules from 'vee-validate/dist/rules';

import Vue from 'vue';

import Vuex from 'vuex';

import $ from 'jquery';

import {BootstrapVue, CardPlugin, InputGroupPlugin, ModalPlugin, TooltipPlugin, PopoverPlugin, DropdownPlugin, ToastPlugin, BadgePlugin, TabsPlugin, IconsPlugin, PaginationPlugin } from 'bootstrap-vue';

import 'bootstrap/dist/css/bootstrap.css';

import 'bootstrap-vue/dist/bootstrap-vue.css';

import Amplify, * as AmplifyModules from 'aws-amplify';

import { AmplifyPlugin } from 'aws-amplify-vue';

import {
  Alert,
  Button,
  Layout,
  Icon,
  Tooltip,
  Dropdown,
  Avatar,
  Spin,
  AutoComplete,
  Input,
  Menu,
  Popover,
  Badge,
  Tabs,
  List,
  Tag,
  Row,
  Col,
  Card,
  DatePicker,
  Radio,
  Table,
  Divider,
  Breadcrumb,
  Form,
  Select,
  Popconfirm,
  Modal,
  Checkbox,
  PageHeader,
  Empty,
  FormModel,
  Skeleton,
  Steps,
  Result,
  Statistic,
  message,
} from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';

import 'vue-multiselect/dist/vue-multiselect.min.css';
import Multiselect from 'vue-multiselect';

import App from './App.vue';
import awsconfig from './aws-exports';
import router from './router';

import store from './store/index';


Amplify.configure(awsconfig);
Vue.use(AmplifyPlugin, AmplifyModules);

const {
  Content, Header, Footer, Sider,
} = Layout;
const {
  Step,
} = Steps;
const MenuItem = Menu.Item;
const MenuDivider = Menu.Divider;
const MenuSubMenu = Menu.SubMenu;
const TabsTabPane = Tabs.TabPane;
const ListItem = List.Item;
const ListItemMeta = List.Item.Meta;
const { RangePicker } = DatePicker;
const RadioGroup = Radio.Group;
const RadioButton = Radio.Button;
const CardGrid = Card.Grid;
const CardMeta = Card.Meta;
const BreadcrumbItem = Breadcrumb.Item;
const FormItem = Form.Item;
const FormModelItem = FormModel.Item;

Spin.setDefaultIndicator({
  // eslint-disable-next-line no-unused-vars
  indicator: {
    render() {
      return '<a-icon slot="indicator" type="loading" style="font-size: 24px" spin />';
    },
  },
});

Vue.component(Alert.name, Alert);
Vue.component(Checkbox.name, Checkbox);
Vue.component(Button.name, Button);
Vue.component(Button.Group.name, Button.Group);
Vue.component(Layout.name, Layout);
Vue.component(Icon.name, Icon);
Vue.component(Tooltip.name, Tooltip);
Vue.component(Dropdown.name, Dropdown);
Vue.component(Avatar.name, Avatar);
Vue.component(Spin.name, Spin);
Vue.component(AutoComplete.name, AutoComplete);
Vue.component(Input.name, Input);
Vue.component(Menu.name, Menu);
Vue.component(MenuItem.name, MenuItem);
Vue.component(MenuDivider.name, MenuDivider);
Vue.component(Popover.name, Popover);
Vue.component(Badge.name, Badge);
Vue.component(Tabs.name, Tabs);
Vue.component(TabsTabPane.name, TabsTabPane);
Vue.component(List.name, List);
Vue.component(ListItem.name, ListItem);
Vue.component(ListItemMeta.name, ListItemMeta);
Vue.component(Tag.name, Tag);
Vue.component(Tag.CheckableTag.name, Tag.CheckableTag);
Vue.component(MenuSubMenu.name, MenuSubMenu);
Vue.component(Row.name, Row);
Vue.component(Col.name, Col);
Vue.component(Card.name, Card);
Vue.component(CardGrid.name, CardGrid);
Vue.component(CardMeta.name, CardMeta);
Vue.component(DatePicker.name, DatePicker);
Vue.component(RangePicker.name, RangePicker);
Vue.component(Radio.name, Radio);
Vue.component(RadioGroup.name, RadioGroup);
Vue.component(RadioButton.name, RadioButton);
Vue.component(Table.name, Table);
Vue.component(Divider.name, Divider);
Vue.component(Breadcrumb.name, Breadcrumb);
Vue.component(BreadcrumbItem.name, BreadcrumbItem);
Vue.component(Form.name, Form);
Vue.component(FormModel.name, FormModel);
Vue.component(FormModelItem.name, FormModelItem);
Vue.component(FormItem.name, FormItem);
Vue.component(Select.name, Select);
Vue.component(Select.Option.name, Select.Option);
Vue.component(Popconfirm.name, Popconfirm);
Vue.component(Modal.name, Modal);

Vue.prototype.$message = message;

Vue.component(Content.name, Content);
Vue.component(Header.name, Header);
Vue.component(PageHeader.name, PageHeader);
Vue.component(Footer.name, Footer);
Vue.component(Sider.name, Sider);
Vue.component(Empty.name, Empty);
Vue.component(Skeleton.name, Skeleton);
Vue.component(Steps.name, Steps);
Vue.component(Step.name, Step);
Vue.component(Result.name, Result);
Vue.component(Statistic.name, Statistic);


library.add(faChevronRight);
library.add(faChevronDown);
library.add(faArrowAltCircleUp);
library.add(faArrowAltCircleDown);
library.add(faPlusSquare);
library.add(faWindowClose);
library.add(faMinusSquare);
library.add(faChevronCircleDown);
library.add(faChevronCircleRight);
library.add(faStop);
library.add(faPlay);
library.add(faMinus);
library.add(faPlus);
library.add(faPlusCircle);
library.add(faCheckCircle);
library.add(faTimesCircle);
library.add(faSave);
library.add(faCogs);
library.add(faBan);
library.add(faCircle);
library.add(faChartPie);
library.add(faRedo);
library.add(faInfoCircle);
library.add(faNetworkWired);
library.add(faTrashAlt);
library.add(faCloudDownloadAlt);
library.add(faTags);
library.add(faBookmark);
library.add(faEdit);
library.add(faClipboard);
library.add(faLink);
library.add(faKey);
library.add(faLock);
library.add(faUnlock);
library.add(faEllipsisV);
library.add(faEllipsisH);
library.add(faArrowLeft);
library.add(faArrowRight);
library.add(faCog);
library.add(faStopCircle);
library.add(faMapPin);
library.add(faInfinity);
library.add(faTimes);
library.add(faDownload);
library.add(faUpload);
library.add(faBolt);
library.add(faFileExport);
library.add(faFileExcel);

Vue.component('font-awesome-icon', FontAwesomeIcon);

// Install VeeValidate rules and localization
Object.keys(rules).forEach((rule) => {
  // @ts-ignore
  extend(rule, rules[rule]);
});

localize('en', en);

// Install VeeValidate components globally
Vue.component('ValidationObserver', ValidationObserver);
Vue.component('ValidationProvider', ValidationProvider);

Vue.component('multiselect', Multiselect);


Vue.use(BootstrapVue);
Vue.use(CardPlugin);
Vue.use(InputGroupPlugin);
Vue.use(ModalPlugin);
Vue.use(TooltipPlugin);
Vue.use(PopoverPlugin);
Vue.use(DropdownPlugin);
Vue.use(ToastPlugin);
Vue.use(BadgePlugin);
Vue.use(TabsPlugin);
Vue.use(IconsPlugin);
Vue.use(PaginationPlugin);

import CountryFlag from 'vue-country-flag';
Vue.component('country-flag', CountryFlag);

import Clipboard from 'v-clipboard';
Vue.use(Clipboard);


// Vue.use(VueInputMask);

Vue.config.productionTip = false;
Vue.config.performance = true;


new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
